export enum ConsoleResourceType {
    Rules = 'rules',
}
